<!-- 客户信用额度管理 -->
<template>
  <div>
    <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :defaults.sync="defaults" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel"
      :row-class-name="getRowClassName" @search-change="searchChange" @search-reset="searchReset" @refresh-change="refreshChange" :beforeOpen="beforeOpen" @current-change="currentChange" @size-change="sizeChange" @on-load="onLoad"
      @selection-change="selectionChange">
      <!-- 自定义操作列 -->
      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="small" icon="el-icon-edit" @click="handleEdit(row)">
          编辑
        </el-button>
        <el-button type="text" size="small" icon="el-icon-view" @click="handleView(row)">
          查看
        </el-button>
      </template>
    </avue-crud>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, getDetail } from "./api";
// import { getSearchTimeConfig } from "@/basic-common/util/common";

export default {
  name: "customer-credit-limit",
  mixins: [crudMixins],
  components: {},
  data () {
    return {
      apiConfig: { getList, getDetail },
      defaultParams: {
        businessType: "2", // 汽车出库业务类型
      },
      option: {
        ...this.$store.state.publicOption,
        menu: false,
        addBtn: false,
        delBtn: false,
        editBtn: false,
        searchMenuSpan: 6,
        column: [
          {
            label: "客户",
            prop: "custNo",
            overHidden: true, // 表格超出隐藏
            type: "select",
            remote: true,
            search: true,
            dicUrl: '/api/produce/blade-dept/select/distinct/select',
            props: {
              label: 'deptName',
              value: 'id'
            },
          },
          {
            label: "合同名称",
            prop: "contractName",
            overHidden: true,
            search: false,
            rules: [
              {
                required: true,
                message: "请输入合同名称",
                trigger: "blur",
              },
            ],
          },
          {
            label: "计划量",
            prop: "planAmount",
            type: "number",
            overHidden: true,
            search: false,
            formatter: (row) => {
              return row.plannedQuantity ? `${row.plannedQuantity}吨` : "-";
            },
          },
          {
            label: "执行量",
            prop: "executeAmount",
            type: "number",
            overHidden: true,
            search: false,
            formatter: (row) => {
              return row.executedQuantity ? `${row.executedQuantity}吨` : "-";
            },
          },
          {
            label: "执行进度",
            prop: "executeRate",
            type: "number",
            overHidden: true,
            search: false,
            formatter: (row) => {
              return row.executionProgress ? `${row.executionProgress}%` : "-";
            },
          },
          {
            label: "预付款",
            prop: "advancePayment",
            type: "number",
            overHidden: true,
            search: false,
            formatter: (row) => {
              return row.advancePayment
                ? `¥${row.advancePayment.toLocaleString()}`
                : "-";
            },
          },
          {
            label: "现金预付款",
            prop: "cashPreMoney",
          },
          {
            label: "承兑预付款",
            prop: "acceptPreMoney",
          },
          {
            label: "信用额度",
            prop: "creditLimit",
            type: "number",
            overHidden: true,
            search: false,
            formatter: (row) => {
              return row.creditLimit
                ? `¥${row.creditLimit.toLocaleString()}`
                : "-";
            },
          },
          {
            label: "风险状态",
            prop: "riskStatus",
            type: "select",
            overHidden: true,
            search: true,
            showColumn: false,
            dataType: "string",
            dicData: this.$store.getters.commonDict['risk_status'],
            slot: true,
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
        ],
      },
    };
  },
  mounted () {
    // 初始化数据
    this.onLoad();
  },
  methods: {
    // 编辑操作
    handleEdit (row) {
      this.$message.info("编辑功能待实现");
      console.log("编辑客户信用额度:", row);
    },

    // 查看操作
    handleView (row) {
      this.$message.info("查看功能待实现");
      console.log("查看客户信用额度:", row);
    },
    // 根据风险状态设置行样式类名
    getRowClassName ({ row, rowIndex }) {
      const riskStatus = row.riskStatus;
      if (riskStatus === 0) {
        return "risk-normal"; // 正常 - 默认白色背景
      } else if (riskStatus === 1) {
        return "risk-low"; // 低风险 - 浅绿色背景
      } else if (riskStatus === 2) {
        return "risk-medium"; // 中风险 - 浅黄色背景
      } else if (riskStatus === 3) {
        return "risk-high"; // 高风险 - 浅红色背景
      }
      return ""; // 默认样式
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;

  p {
    color: #000000;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    margin: 0;
  }
}

// 自定义搜索表单样式
::v-deep .avue-crud__search {
  .el-form-item__label {
    font-weight: 500;
    color: #606266;
  }

  .el-input__inner {
    border-radius: 4px;
  }

  .el-button--primary {
    background-color: #409eff;
    border-color: #409eff;
  }

  .el-button--default {
    background-color: #f5f7fa;
    border-color: #dcdfe6;
    color: #606266;
  }
}

// 自定义表格样式
::v-deep .avue-crud__table {
  .el-table__header {
    th {
      background-color: #fafafa;
      color: #606266;
      font-weight: 500;
    }
  }

  .el-table__row {
    &:hover {
      background-color: #f5f7fa;
    }
  }
}

// 风险状态标签样式
::v-deep .el-tag {
  border-radius: 12px;
  padding: 0 8px;
  font-size: 12px;
  font-weight: 500;
}

// 自定义搜索表单样式
::v-deep .avue-crud__search {
  .el-form-item__label {
    font-weight: 500;
    color: #606266;
  }

  .el-input__inner {
    border-radius: 4px;
    border: 1px solid #dcdfe6;

    &:focus {
      border-color: #409eff;
    }
  }

  .el-button--primary {
    background-color: #409eff;
    border-color: #409eff;
  }

  .el-button--default {
    background-color: #f5f7fa;
    border-color: #dcdfe6;
    color: #606266;
  }
}

// 自定义表格样式
::v-deep .avue-crud__table {
  .el-table__header {
    th {
      background-color: #fafafa;
      color: #606266;
      font-weight: 500;
    }
  }

  .el-table__row {
    &:hover {
      background-color: #f5f7fa;
    }
  }
}

// 风险状态标签样式
::v-deep .el-tag {
  border-radius: 12px;
  padding: 0 8px;
  font-size: 12px;
  font-weight: 500;
}

::v-deep .el-input__icon {
  line-height: 1 !important;
}
</style>
